import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import Logo from "./nabeel.JPG";

const Home = () =>{
   return(
    <>
    <section className="home" id="home">
        <div className="home-content">
            <h1>Hi, I am <span>Mohamed Nabeel</span></h1>
            <h3 className="text-animation">I'm a <span></span></h3>
                <p className="para">Hello! I'm a passionate and skilled web developer in designing and 
                    building user-friendly websites and web applications.My expertise lies in 
                    creating seamless and responsive user experiences,bringing creative visions 
                    to life through clean, efficient code.</p>
                
                <div className="social-icons">
                    <NavLink to="https://www.linkedin.com/in/mohamednabeel1004/"><FontAwesomeIcon icon={faLinkedin} /></NavLink>
                    <NavLink to="https://github.com/MohamedNabeel04" ><FontAwesomeIcon icon={faGithub}  /></NavLink>
                    
                </div>
                <div className="btn-group">
                    <NavLink to="/contact"className="btn">Contact</NavLink>
                    <NavLink to="https://drive.google.com/file/d/1oVUFb-_Gac_m3OFJXZpKnpq8YU_j41jB/view?usp=sharing"className="btn">DOWNLOAD CV</NavLink>
                </div>
            </div>
            <div className="home-img">
                <img src= {Logo} alt="Nabeel image" />
            </div>
    </section>
    </>
   ) 
}
export default Home;